import React from 'react';
import LandingPage from './LandingPage';

export default function HomeScreen(): React.JSX.Element {
  return <LandingPage />;
}
